import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroll-component'
import {BatchCard} from '../../../../../helpers/elements/card/batch-card/BatchCard'
import {BatchCompleted} from '../../../../../interfaces/batch'
import {useGetScheduleBatchesQuery} from '../../../../../redux/api/services/batch'
import {ListViewProvider, useListView} from '../core/ListViewProvider'
import {BatchCancelModal} from './batch-cancel-modal/BatchCancelModal'
import {BatchEditModal} from './batch-edit-modal/BatchEditModal'
import {TitleCard} from '../../../../../helpers/elements/card/TitleCard'
import {KTSVG, toAbsoluteUrl} from '../../../../../template/_metronic/helpers'
import {ListLoading} from '../../../../../helpers/elements/table/loading/ListLoading'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../redux/store'
import {CustomErrorAlert} from '../../../../../libs/_fri/components/CustomErrorAlert/CustomErrorAlert'

function BatchList() {
  const [page, setPage] = useState(1)
  const [timeStamp, setTimeStamp] = useState('')
  const infoState = useSelector((state: RootState) => state.info)

  const {data, isFetching, isError, error, refetch} = useGetScheduleBatchesQuery({
    info: infoState,
    requestContent: {page: page, pageSize: 10},
  })
  const {batchForUpdate, batchForCancel, setBatchForUpdate, setBatchForCancel} = useListView()

  useEffect(() => {
    if (timeStamp === '' && page !== 1) return
    refetch()
  }, [timeStamp])

  return (
    <>
      <CustomErrorAlert show={isError} error={error} />
      {isFetching && <ListLoading />}

      {data?.responseContent && data?.responseContent.length > 0 ? (
        <InfiniteScroll
          dataLength={data?.responseContent.length || 0}
          next={() => setPage((prevPage) => prevPage + 1)}
          hasMore={(data?.responseContent.length || 0) >= page * 10}
          loader={<h4>Cargando...</h4>}
          endMessage={
            <p style={{textAlign: 'center'}}>
              <b>¡Llegó al final de la lista!</b>
            </p>
          }
        >
          {data?.responseContent.map((item: BatchCompleted) => (
            <BatchCard
              key={item.id}
              title={item.title}
              subtitle={'Ref: ' + item.reference}
              icon={true}
              columns={[
                {
                  title: 'Pagos a realizar',
                  className: '',
                  value: (
                    <>
                      <span className='text-success'>{item.validRecords}</span>
                      <span className='text-gray'> / {item.totalRecords}</span>
                    </>
                  ),
                },
                {
                  title: 'Fecha de creación',
                  className: '',
                  value: <span className='text-primary-dark'>{item.formattedCreationDate}</span>,
                },
                {
                  title: 'Fecha a ejecutar',
                  className: '',
                  value: <span className='text-primary-dark'>{item.formattedScheduledDate}</span>,
                },
                {
                  title: 'Monto a pagar',
                  className: 'text-xxl-end',
                  value: <span className='text-primary-dark'>{item.paidAmount}</span>,
                },
                {
                  title: 'Acciones',
                  className: 'flex-nowrap text-end',
                  value: (
                    <>
                      <a
                        className='btn btn-md btn-icon btn-light-primary btn-circle btn-active-primary me-3'
                        onClick={() => {
                          setBatchForCancel(item)
                        }}
                      >
                        <KTSVG path='/media/soyfri-media/trash.svg' className='svg-icon-2' />
                      </a>
                      <a
                        className='btn btn-md btn-icon btn-light-primary btn-circle btn-active-primary me-3'
                        onClick={() => {
                          setBatchForUpdate(item)
                        }}
                      >
                        <KTSVG path='/media/soyfri-media/edit.svg' className='svg-icon-2' />
                      </a>
                      <Link
                        className='btn btn-md btn-icon btn-light-primary btn-circle btn-active-primary'
                        to={`/scheduled/${item.id}/detail`}
                      >
                        <KTSVG
                          path='/media/soyfri-media/arrow-right-short.svg'
                          className='svg-icon-2'
                        />
                      </Link>
                    </>
                  ),
                },
              ]}
            />
          ))}
        </InfiniteScroll>
      ) : (
        <div className='text-center'>
          <img
            src={toAbsoluteUrl('/media/illustrations/sigma-1/5.png')}
            className='mw-100 mh-200px'
            alt=''
          />
          <div className='d-flex flex-column py-5'>
            <span className='fw-semibold text-primary-dark fs-2qx'>
              ¡No tienes pagos programados actualmente!
            </span>
            <div className='text-primary-dark fs-4'>Crea nuevos pagos fri y apareceran aqui.</div>
          </div>
          <Link to='/upload-file' className='btn btn-sm btn-primary'>
            Crea un pago fri
          </Link>
        </div>
      )}

      {batchForUpdate && <BatchEditModal />}
      {batchForCancel && <BatchCancelModal />}
    </>
  )
}

export function BatchListWrapper() {
  return (
    <>
      <TitleCard title='Pagos programados' subtitle='Listado de pagos' />
      <ListViewProvider>
        <BatchList />
      </ListViewProvider>
    </>
  )
}
